import { createGlobalStyle } from "styled-components";

const LrfStyle = createGlobalStyle`
.main-wrap{
    width: 40%;
    
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 30px #272727 inset !important;
  -webkit-text-fill-color: #fff !important; /* Set the text color*/
  color: #fff !important;
}
    .form-wrap{
        box-shadow: 0px 2px 4px rgb(15 34 58 / 12%);
        padding: 25px 60px;
        height: calc(100vh - 0px);
        overflow: auto;
        justify-content: center;
        .logo{
            min-width: 228px;
        }
        .form-input{
            border-bottom: 0.5px solid #FFFFFF!important;
            background: transparent;
            border: unset;
            width: 100%;
            outline: none;
            border: unset;
            border-radius: unset;
            background-color: transparent!important;
            padding: unset;
        }
        .form-input-danger{
            border-bottom: 0.5px solid #dc3545!important;
        }
        .InputIcon{
            position: absolute;
            right: 0;
            top: 15px;
        }
        .form-button{
            color: #000;
            box-sizing: border-box;
            border-radius: 24px;
            text-transform: uppercase;
            padding: 16px 0;
            width: 80%;
            border: unset;
            font-weight: 700;
            transition: all 0.25s linear 0s;
            background: #BDFF00;
            :disabled{
                border: 2px solid #BDFF00;
                background: transparent;
                color: #BDFF00;
            }
        }
    }   
}
`;

export default LrfStyle;
